import { IconProps } from "../../types/utils";

const Male = ({ color, dimension, ...props }: IconProps) => (
  <svg
    width={dimension || 32}
    height={dimension || 32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.0115 10.6972C16.3218 10.6972 14.7713 11.2786 13.5315 12.2441L9.79377 8.50289H12.7086C13.2132 8.50289 13.6229 8.097 13.6229 7.5886C13.6229 7.08396 13.2132 6.67432 12.7086 6.67432H7.5886C7.52646 6.67432 7.46789 6.68164 7.40932 6.69253C7.38003 6.69985 7.3545 6.71075 7.32896 6.71807C7.29967 6.72539 7.26682 6.73271 7.23753 6.74735C7.20825 6.75842 7.17539 6.77664 7.1461 6.79485C7.12414 6.80593 7.10217 6.81682 7.08021 6.82789C6.98146 6.89735 6.8936 6.98146 6.82789 7.08396C6.81325 7.10593 6.80593 7.12789 6.79128 7.14986C6.77664 7.17914 6.75843 7.20842 6.74378 7.24128C6.73271 7.27057 6.72557 7.29985 6.7145 7.33271C6.70717 7.35825 6.69628 7.38396 6.69253 7.41307C6.68164 7.47164 6.67432 7.53003 6.67432 7.5886V12.7086C6.67432 13.217 7.08396 13.6229 7.5886 13.6229C8.09325 13.6229 8.50289 13.217 8.50289 12.7086V9.79752L12.2404 13.535C11.275 14.7748 10.6972 16.3256 10.6972 18.0115C10.6972 22.0454 13.9775 25.3257 18.0115 25.3257C22.0452 25.3257 25.3257 22.0454 25.3257 18.0115C25.3257 13.9813 22.0452 10.6972 18.0115 10.6972V10.6972ZM18.0115 23.4972C14.987 23.4972 12.5257 21.0397 12.5257 18.0115C12.5257 14.987 14.987 12.5257 18.0115 12.5257C21.0359 12.5257 23.4972 14.987 23.4972 18.0115C23.4972 21.0397 21.0359 23.4972 18.0115 23.4972Z"
      fill={color || "#242424"}
    />
  </svg>
);

export default Male;
